import React, { useState, useEffect } from 'react';
import { Button, Menu, Checkbox, Tag, Badge, Empty, Spin, Image, Divider, Drawer } from 'antd';
import useZuStore from 'store/zustand/zustand-store';
import { ze } from 'utils/zhEn';
import { CloseOutlined } from '@ant-design/icons';
import scss from './AiDrawer.scss';
import AiIssueAnalysisDrawerBody from 'components/top/AiDrawer/AiIssueAnalysisDrawerBody';
import AiStackAnalysisDrawerBody from 'components/top/AiDrawer/AiStackAnalysisDrawerBody';
import AiAssemblyAnalysisDrawerBody from 'components/top/AiDrawer/AiAssemblyAnalysisDrawerBody';
import AiDrawerAutoScrollBody from 'components/top/AiDrawer/AiDrawerAutoScrollBody';
import AiChatBotEx from 'components/top/AiDrawer/AiChatBotEx';
import { withRouter } from 'react-router-dom';
import CsDraggableDrawer from 'components/antd-extension/CsDraggableDrawer';
import classNames from 'classnames';
import { AiContentType } from 'utils/constants/ai-enums';

const AiDrawer = (props) => {
  const {
    location,
  } = props;

  // 当pathname改变的时候关闭drawer
  useEffect(() => {
    onClickClose();
  },[location?.pathname]);

  const aiDrawerSlice = useZuStore().aiDrawer;
  const visible = aiDrawerSlice.visible;
  const chatBotFullscreen = aiDrawerSlice.chatBotFullscreen;

  // 内容类型直接从 zustand store 读取（由各 start* action 设置），
  // 不再通过 useEffect 监听 trigger 变化来切换，避免固定 trigger 时 useEffect 不触发的问题
  const currentAiContentType = aiDrawerSlice.activeContentType || null;
  const [drawerWidth, setDrawerWidth] = useState('max(320px, 33vw)');

  function onClickClose() {
    aiDrawerSlice.setVisible(false);
  }

  function onWidthChange(newWidth) {
    setDrawerWidth(newWidth);
  }


  // 非ChatBot类型的AI助手的header
  const headerDom = <div
    className={scss.header}
  >
    <div className={scss.headerTitle}>{ ze('CrashSight AI助手', 'CrashSight AI Agent') }</div>
    <div style={{ flexGrow: 1 }}/>
    <CloseOutlined
      style={{ cursor: 'pointer' }}
      onClick={() => onClickClose()}
    />
  </div>;

  let chatBubbleText = '';
  if (currentAiContentType === AiContentType.IssueAnalysis) {
    chatBubbleText = ze('问题分析结果如下：', 'Issue Analysis Result:');
  } else if (currentAiContentType === AiContentType.StackAnalysis) {
    chatBubbleText = ze('堆栈信息分析结果如下：', 'Stack Trace Analysis Result:');
  } else if (currentAiContentType === AiContentType.AsmAnalysis) {
    chatBubbleText = ze('反汇编分析结果如下：', 'Assembly Code Analysis Result:');
  }

  let contentDom;
  if (currentAiContentType === AiContentType.ChatBot) {
    // AiChatBotEx 取代原 AiChatBot，使用新的 AG-UI 协议和 /api/knotAgent 接口
    contentDom = <AiChatBotEx />;
  } else {
    // 其他AI助手仍然使用原有的header和body结构
    const bodyDom = currentAiContentType === AiContentType.IssueAnalysis ? (
      <AiIssueAnalysisDrawerBody
        key={aiDrawerSlice.issueAnalysisTrigger}
        issueId={aiDrawerSlice.issueAnalysisIssueId}
        trigger={aiDrawerSlice.issueAnalysisTrigger}
      />
    ) : (
      <AiDrawerAutoScrollBody>
        <div className={classNames(scss.chatBubbleContainer, scss.chatBubble)}>
          { chatBubbleText && <div style={{ marginBottom: '20px' }}>{ chatBubbleText }</div> }
          { currentAiContentType === AiContentType.StackAnalysis && <AiStackAnalysisDrawerBody
            trigger={aiDrawerSlice.stackAnalysisTrigger}
          /> }
          { currentAiContentType === AiContentType.AsmAnalysis && <AiAssemblyAnalysisDrawerBody
            trigger={aiDrawerSlice.asmAnalysisTrigger}
            crashId={aiDrawerSlice.asmAnalysisCrashId}
            asmCode={aiDrawerSlice.asmAnalysisAsmCode}
          /> }
        </div>
      </AiDrawerAutoScrollBody>
    );

    contentDom = <div className={scss.aiDrawer}>
      { headerDom }
      <Divider style={{ margin: '0' }}/>
      { bodyDom }
    </div>;
  }

  // 根据全屏状态决定drawer的宽度和是否禁用拖拽
  const finalDrawerWidth = chatBotFullscreen ? '100%' : drawerWidth;
  const disableDrag = chatBotFullscreen;

  const drawerDom = <CsDraggableDrawer
    placement='right'
    closable={false}
    mask={false}
    onClose={() => onClickClose()}
    open={visible}
    width={finalDrawerWidth}
    onWidthChange={onWidthChange}
    disableDrag={disableDrag}
    destroyOnClose={false}
    bodyStyle={{
      backgroundColor: '#f2f4f8',
      padding: 0,
    }}
  >
    { contentDom }
  </CsDraggableDrawer>;

  return drawerDom;
};
export default withRouter(AiDrawer);
